import '../styles/home-styles.css';
import "../extensions/leaflet-search/leaflet-search.min.js";
import "../extensions/leaflet-search/leaflet-search.min.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/regular';
import BaseLeaf from "@/my-leaf/base/base-leaf";
import { eventBus } from '@/main';

// import { AIOLayer } from '@/my-leaf/layers/aio-layer';
import { NavareaLayer } from '@/my-leaf/layers/navarea-layer';
import { PortsLayer } from '@/my-leaf/layers/ports-layer';
import { ShipsLayer } from '@/my-leaf/layers/ships-layer';

export class HomeLeaf extends BaseLeaf {
    constructor(elementId, options = {}) {
        const homeLeafOptions = {
            ...options,
            preferCanvas: false // Запрещаем использование Canvas для совместимости с несколькими слоями
        };

        super(elementId, homeLeafOptions);
        this.enabledLayers = [];

        // Слои карты, инициализируем позже
        // this.aioLayer = null;
        this.navareaLayer = null;
        this.shipsLayer = null;
        this.portsLayer = null;
    }

    // Инициализация карты и базового класса
    async init(el, tiles) {
        super.init(el, tiles);
    
        if (!this.map) {
            console.error("Failed to initialize map");
            return Promise.reject();
        }
        return;        
    }    
    
    // Инициализация слоев карты
    async initLayers() {
        if (!this.map) return Promise.reject();

        // Инициализируем слои
        this.shipsLayer = new ShipsLayer(this.map, this.layerControl);
        this.shipsLayer.addShipLayer();

        this.portsLayer = new PortsLayer(this.map, this.layerControl);
        this.portsLayer.addPortsLayer();

        // this.aioLayer = new AIOLayer(this.map, this.layerControl);
        // this.aioLayer.addAIOLayer()

        // НЕ добавляем слой Navarea при инициализации
        // Слой будет добавлен/удалён динамически при смене выбранного корабля
        // в зависимости от наличия подписки на сервис Navarea

        return
    }

    // Отрисовка кораблей
    drawShips(ships, selectedShipId = null) {
            if (!this.shipsLayer) {
            console.warn("ShipsLayer not initialized yet, skipping drawShips");
            return;
        }
        
        return this.shipsLayer.drawShips(ships, selectedShipId);
    }    

    // Центровка по выбранному кораблю и отображение попапа
    setSelectedShip(deviceId) {
        if (!this.shipsLayer) {
            console.warn("ShipsLayer not initialized yet, skipping setSelectedShip");
            return;
        }
        
        return this.shipsLayer.setSelectedShip(deviceId);
    } 
    
    // Отключаем все overlay слои в layerControl
    disableAllOverlays() {
        if (!this.layerControl) return;

        // Получаем все overlay слои из layerControl
        const overlays = this.layerControl._layers;
        
        for (let layerId in overlays) {
            const layerObj = overlays[layerId];
            
            // Проверяем, что это overlay слой (не base layer)
            if (layerObj.overlay && this.map.hasLayer(layerObj.layer)) {
                // Отключаем слой с карты
                this.map.removeLayer(layerObj.layer);
            }
        }
    }

    // Очищаем все слои
    // Методы для управления Navarea слоем
    
    /**
     * Добавить слой Navarea на карту
     * Вызывается когда выбран корабль с подпиской на Navarea
     */
    addNavareaLayer() {
        if (!this.map) return;
        
        // Если слой уже существует и добавлен, ничего не делаем
        if (this.navareaLayer && this.map.hasLayer(this.navareaLayer.overlays?.navarea)) {
            return;
        }
        
        // Если слой не создан, создаём его
        if (!this.navareaLayer) {
            this.navareaLayer = new NavareaLayer(this.map, this.layerControl);
        }
        
        // Добавляем слой на карту
        this.navareaLayer.addNavareaLayer();
        console.log('[HomeLeaf] Navarea layer added');
    }
    
    /**
     * Удалить слой Navarea с карты
     * Вызывается когда у выбранного корабля нет подписки на Navarea
     */
    removeNavareaLayer() {
        if (!this.navareaLayer) return;
        
        try {
            // Удаляем слой с карты если он добавлен и карта ещё жива
            if (this.map && this.navareaLayer.overlays?.navarea) {
                try {
                    if (this.map.hasLayer(this.navareaLayer.overlays.navarea)) {
                        this.map.removeLayer(this.navareaLayer.overlays.navarea);
                    }
                } catch (e) {
                    console.warn('[HomeLeaf] Error removing layer from map:', e);
                }
            }
            
            // Очищаем слой только если карта еще существует
            if (this.map) {
                this.navareaLayer.destroy();
            }
            this.navareaLayer = null;
            console.log('[HomeLeaf] Navarea layer removed');
        } catch (error) {
            console.warn('[HomeLeaf] Error removing Navarea layer:', error);
            this.navareaLayer = null;
        }
    }

    destroy() {
        try {
            // Отключаем все event listeners сначала
            // if (typeof eventBus !== 'undefined' && eventBus) {
            //     eventBus.$off('close-aio-popup');
            //     eventBus.$off('highlight-aio-on-map');
            //     eventBus.$off('clear-aio-highlight');
            // }

            // Очищаем все слои с детальной очисткой
            // if (this.aioLayer) {
            //     this.aioLayer.destroy();
            //     this.aioLayer = null;
            // }

            if (this.navareaLayer) {
                this.navareaLayer.destroy();
                this.navareaLayer = null;
            }

            if (this.portsLayer) {
                this.portsLayer.destroy();
                this.portsLayer = null;
            }

            if (this.shipsLayer) {
                this.shipsLayer.destroy();
                this.shipsLayer = null;
            }

            // Очищаем массив включенных слоев
            if (this.enabledLayers) {
                this.enabledLayers.length = 0;
                this.enabledLayers = null;
            }

            // Вызываем родительский destroy
            super.destroy();
            
        } catch (error) {
            console.warn('Ошибка при очистке HomeLeaf:', error);
            
            // В случае ошибки все равно обнуляем ссылки
            // this.aioLayer = null;
            this.navareaLayer = null;
            this.portsLayer = null;
            this.shipsLayer = null;
            this.enabledLayers = null;
            
            // Все равно вызываем родительский destroy
            super.destroy();
        }
    }
}
